var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                page: _vm.page,
                data: _vm.tableData,
                permission: _vm.permissionList,
                "table-loading": _vm.tableLoading,
                option: _vm.tableOption,
                "before-open": _vm.handleOpenBefore,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "search-change": _vm.searchChange,
                "refresh-change": _vm.refreshChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "row-update": _vm.handleUpdate,
                "row-save": _vm.handleSave,
                "row-del": _vm.handleDel,
              },
              scopedSlots: _vm._u([
                {
                  key: "role",
                  fn: function (scope) {
                    return _vm._l(scope.row.roleList, function (r, index) {
                      return _c(
                        "span",
                        { key: index },
                        [
                          _c("el-tag", [_vm._v(_vm._s(r.roleName) + " ")]),
                          _vm._v("  \n        "),
                        ],
                        1
                      )
                    })
                  },
                },
              ]),
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm.permissions.app_appuser_export
                    ? _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            plain: "",
                            type: "primary",
                            size: "small",
                            icon: "el-icon-download",
                          },
                          on: { click: _vm.exportExcel },
                        },
                        [_vm._v("导出\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "template",
                { slot: "roleForm" },
                [
                  _c("avue-select", {
                    attrs: {
                      dic: _vm.rolesOptions,
                      props: _vm.roleProps,
                      multiple: "",
                      placeholder: "请选择角色",
                    },
                    model: {
                      value: _vm.role,
                      callback: function ($$v) {
                        _vm.role = $$v
                      },
                      expression: "role",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }